<template>
  <div class="border border-secondary py-3 px-2">
    <FITModal :title="$t('adm.userAuthorization.change.modal.title')" :noFooter="false" reference="confirmation" ref="confirmation" @click="onConfirm">
      <div slot="body">{{ $t('adm.userAuthorization.change.modal.body') }}</div>
    </FITModal>
    <h5> {{ $t('adm.userAuthorization.change.header') }}</h5>
    <p v-if="candidates.length > 0">
      <b class="text-danger">{{ $t('adm.userAuthorization.change.selectedCandidate') }}: {{names.join(', ')}}</b>
    </p>
    <b-row>
      <b-col cols="5">
        <FITSelect v-model="selectedRole" :width="10" :label="$t('adm.userAuthorization.change.role')" :options="options"></FITSelect>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="primary" @click="confirm">{{ $t('adm.userAuthorization.change.applyChanges') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  FITFormCard,
  FITSelect,
  FITModal
} from '@/components';
import Vue from 'vue'
export default {
  name: 'AuthorizationChange',
  components: {
    FITFormCard,
    FITSelect,
    FITModal
  },
  props: {
    candidates: {
      type: Array,
      default: () => { return [] }
    },

    callback: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      selectedRole: '1',
      options: [],
    }
  },

  computed: {
    names() {
      return this.candidates.map((cand) => {
        return `${cand.englishName} (${cand.chineseName})`
      })
    }
  },

  created() {
    this.$store.dispatch('UserAuthorization/getAuthorizationOption')
      .then((json) => {
        Vue.set(this, 'options', json.data.map((role) => {
          return {
            text: role.name,
            value: role.ID
          }
        }));
      })
      .catch((err) => {
        console.error(err);
      })
  },

  methods: {
    confirm(evt) {
      evt.preventDefault();
      this.$refs.confirmation.openModal();
    },

    onConfirm(accepted) {

      if (!accepted) {
        return;
      }

      var params = this.candidates.map((user) => {
        var userRole = {
          userID: user.ID,
          roleID: this.selectedRole, // roleID
        };

        if (user.version) {
          userRole['version'] = user.version
        }
        return userRole
      });

      this.$store.dispatch('UserAuthorization/grantOrRevokeAuthorization', {
        permission: params
      }).then((json) => {
        if (this.callback.onSuccess) {
          this.callback.onSuccess(json)
        }
      }).catch((error) => {
        if (this.callback.onError) {
          this.callback.onError(error)
        }
      });
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/Adm/UserAuthorization/components/AuthorizationChange.vue